import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Topbar } from "@components";
import { PUBLIC_ROUTE } from "@router/route.constants";
import {
	SpinWrapper,
	RootContainer,
	HistoryBox,
	DateAndAmountContainer,
	Date,
	EmptyText,
	Amount,
	ExpireBox,
	ExpireText,
	ExpiredTime,
	EmptyWrapper,
	HistoryBoxesContainer
} from "./History.style";
import { LIMITS } from "@constants";
import { api } from "@api";
import { Spin, message } from "antd";
import moment from "moment";
import { getFormattedNumber } from "@utils";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";
import { NoSpinHistoryIcon } from "@assets";

const { DEFAULT_PAGE, PAGE_SIZE } = LIMITS;

const History = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const [page, setPage] = useState(DEFAULT_PAGE);
	const [dataLength, setDataLength] = useState(0);

	const getHistory = useCallback(() => {
		setLoading(true);
		api
			.getSpinHistory({
				page,
				limit: PAGE_SIZE,
			})
			.then(({ spin_history, pagination }) => {
				setLoading(false);
				setDataLength(pagination.total);
				setData((prev) => [...prev, ...spin_history]);

				//to test no history
				// setData([]) 

				// to test history when there is no data
				// setData([
				// 	{
				// 		payment_trx_id: "ptx-00000-00000-00000-00000",
				// 		amount: 1000,
				// 		created_at: 1600000000,
				// 		bonus_expired: 1600000000,
				// 	},
				// 	{
				// 		payment_trx_id: "ptx-00000-00000-00000-00000",
				// 		amount: 1000,
				// 		created_at: 1600000000,
				// 		bonus_expired: 1600000000,
				// 	},
				// 	{
				// 		payment_trx_id: "ptx-00000-00000-00000-00000",
				// 		amount: 1000,
				// 		created_at: 1600000000,
				// 		bonus_expired: 1600000000,
				// 	},
				// ]);
			})
			.catch((errorMsg) => message.error(errorMsg));
	}, [page]);

	useEffect(() => {
		getHistory();
	}, [getHistory]);

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
	};

	const EmptyRender = () => {
		return (
			<EmptyWrapper>
				<NoSpinHistoryIcon />
				<EmptyText>{t("common.noRecord")}</EmptyText>
			</EmptyWrapper>
		);
	};

	return (
		<RootContainer>
			<Topbar title={t("spin.historyTitle")} goBack={goBack} />
			{
				!loading && data.length === 0 ? (
					<EmptyRender />
				) : (
					<InfiniteScroll
						dataLength={data.length}
						next={() => {
							setPage((prev) => prev + 1);
						}}
						hasMore={loading || data.length !== dataLength}
						loader={
							<SpinWrapper size={page === 1 ? "large" : "default"}>
								<Spin />
							</SpinWrapper>
						}
					// endMessage={!loading && data.length === 0 && <EmptyRender />}
					>
						<HistoryBoxesContainer>
							{data.map((history, index) => (
								<HistoryBox key={index}>
									<DateAndAmountContainer>
										<Date>
											{moment.unix(history.created_at).format("MMM DD, YYYY")}
											{", "}
											{moment.unix(history.created_at).format("hh:mm:ss A")}
										</Date>
										<Amount>
											{history.amount === 0
												? "Thank you"
												: getFormattedNumber(history.amount) + " Ks."}{" "}
										</Amount>
									</DateAndAmountContainer>

									<ExpireBox>
										<ExpireText> {t("spin.expiredLabel")} </ExpireText>
										<ExpiredTime>
											{moment
												.unix(history.bonus_expired)
												.format("MMM DD, YYYY, hh:mm:ss A")}{" "}
										</ExpiredTime>
									</ExpireBox>
								</HistoryBox>
							))}
						</HistoryBoxesContainer>

					</InfiniteScroll>
				)
			}
		</RootContainer>
	);
};

export default History;
